/**
 * --------------------------------------------------------------------------
 * CoreUI index.esm.js
 * Licensed under MIT (https://github.com/coreui/coreui/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

import Alert from './src/alert.js'
import Button from './src/button.js'
import Carousel from './src/carousel.js'
import Chip from './src/chip.js'
import ChipInput from './src/chip-input.js'
import Collapse from './src/collapse.js'
import Dropdown from './src/dropdown.js'
import Modal from './src/modal.js'
import Navigation from './src/navigation.js'
import OffCanvas from './src/offcanvas.js'
import Popover from './src/popover.js'
import ScrollSpy from './src/scrollspy.js'
import SearchButton from './src/search-button.js'
import Sidebar from './src/sidebar.js'
import Tab from './src/tab.js'
import Toast from './src/toast.js'
import Tooltip from './src/tooltip.js'

export default {
  Alert,
  Button,
  Carousel,
  Chip,
  ChipInput,
  Collapse,
  Dropdown,
  Modal,
  Navigation,
  OffCanvas,
  Popover,
  ScrollSpy,
  SearchButton,
  Sidebar,
  Tab,
  Toast,
  Tooltip
}
